const EquipSupportEmail = "support@equip.health";

const LoginErrors = {
  Default:
    "We’re sorry, something went wrong. Please try again later or contact support@equip.health",
  InvalidCredentials:
    "We didn't recognize that email address or password. For help, please contact support@equip.health",
  InvalidMFA: `That code is incorrect. For help, please contact ${EquipSupportEmail}`,
  NetworkIssues: "No internet connection. Please try again later.",
  UserBlocked:
    "Your account is locked. Please see the instructions sent to you via email or contact support.",
} as const;

enum ResetAppText {
  ConfirmationMessage = "This will clear all app data and restart the app. You will need to log in again.",
  ConfirmationTitle = "Reset app?",
  Trigger = "Reset app",
}

enum LogoutReason {
  AuthError = "AuthError",
  AuthSessionExpiredAtApiCall = "AuthSessionExpiredAtApiCall",
  AuthSessionExpiredAtStartup = "AuthSessionExpiredAtStartup",
  InactivityTimeout = "InactivityTimeout",
  JustPreLoginCleanup = "JustPreLoginCleanup",
  NotAcceptingLogins = "NotAcceptingLogins",
  UserPressedLogout = "UserPressedLogout",
}

export { EquipSupportEmail, LoginErrors, LogoutReason, ResetAppText };
